<section class="lead-hero curve -bottom -white">
    <span class="photo"></span>
    <div class="intro">
        <div class="container">
            <div class="flow">
                <a [routerLink]="['/fund']"><i class="icon icon-arrow-back"></i>
          <span class="text">
            {{language.backfund}}
          </span>
        </a>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <h1 class="title">{{language.favoritepagename}}</h1>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="emptyFav" id="empty-wrapper" class="section section--empty">
    <div class="container">
        <div class="wrapper">
            <header>
                <span class="icon">
          <img src="../../../assets/images/favorite-empty@2x.png" class="img-responsive" alt="favorite icon">
        </span>
                <h1 class="title">{{language.favoritenull}}</h1>
            </header>
            <p>สามารถติดตามกองทุนที่คุณสนใจได้ง่าย ๆ
                <br>เพียงกด
                <span class="favicon active">
          <span rel="border-circle">
            <i class="icon icon-heart"></i>
          </span>
                </span>
                ที่กองทุนที่คุณสนใจ
            </p>
            <footer>
                <a [routerLink]="['/fund']" class="btn btn-primary -brand">เลือกกองทุนที่ติดตาม</a>
            </footer>
        </div>
    </div>
</section>

<section *ngIf="!emptyFav" id="favorite-wrapper" class="section section--investment">
    <div class="container">
        <section class="section-follow">
            <p class="note">
                <span class="text">{{language.favoritecancle}}</span>
                <span class="favicon active"><span rel="border-circle"><i class="icon icon-heart"></i>
          </span></span>
            </p>
        </section>

        <section *ngIf="filterFundList != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar2}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList"></app-fund-card>

        </section>

        <section *ngIf="filterFundList2 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar3}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList2"></app-fund-card>
        </section>

        <section *ngIf="filterFundList3 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar4}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList3"></app-fund-card>

        </section>

        <section *ngIf="filterFundList4 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar6}}</span>
                </h2>
            </header>

            <app-fund-card [renderFundObject]="filterFundList4"></app-fund-card>

        </section>

        <section *ngIf="filterFundList5 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar9}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList5"></app-fund-card>

        </section>

        <section *ngIf="filterFundList6 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar7}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList6"></app-fund-card>

        </section>

        <section *ngIf="filterFundList7 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar14}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList7"></app-fund-card>

        </section>

        <section *ngIf="filterFundList8 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar12}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList8"></app-fund-card>

        </section>

        <section *ngIf="filterFundList9 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar13}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList9"></app-fund-card>

        </section>

        <section *ngIf="filterFundList10 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menudetailbar5}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList10"></app-fund-card>

        </section>

        <section *ngIf="filterFundList11 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar10}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList11"></app-fund-card>

        </section>

        <section *ngIf="filterFundList12 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar16}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList12"></app-fund-card>

        </section>

        <section *ngIf="filterFundList13 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar15}}</span>
                </h2>
            </header>

            <app-fund-card [renderFundObject]="filterFundList13"></app-fund-card>

        </section>

        <section *ngIf="filterFundList14 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar11}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList14"></app-fund-card>

        </section>

        <section *ngIf="filterFundList15 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar1}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList15"></app-fund-card>

        </section>

        <section *ngIf="filterFundList16 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar8}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList16"></app-fund-card>

        </section>
        
        <section *ngIf="filterFundList17 != ''" class="group-fund">
            <header class="heading-title">
                <h2 class="topic-title">
                    <span rel="border-circle">
            <i class="icon icon-etf -white"></i>
          </span>
                    <span class="text">{{language.menutitlebar17}}</span>
                </h2>
            </header>
            <app-fund-card [renderFundObject]="filterFundList17"></app-fund-card>

        </section>

        <div class="note">
            <p class="font-18 color-band">
                <i class="icon icon-star"></i>
                <span class="text">{{language.menu2box5ex}}</span>
            </p>
        </div>

    </div>
</section>

<ngx-ui-loader></ngx-ui-loader>